export type TradeInNotificationType = {
    show: boolean;
    notificationType: TradeInNotificationTypeEnum | null;
    isError: boolean;
};

export enum FinanceUpdateTrigger {
    Initial = "initial",
    PxAdded = "pxAdded",
    PxRemoved = "pxRemoved",
    NewQuote = "newQuote",
    NewConfig = "newConfig",
}

export enum TradeInNotificationTypeEnum {
    Added = "added",
    ReducedDeposit = "reducedDeposit",
    Refused = "refused",
    AddedCarValue = "addedCarValue",
    ReducedDepositCarValue = "reducedDepositCarValue",
    RefusedCarValue = "refusedCarValue",
    RefusedCarValueDeposit = "refusedCarValueDeposit",
    AddedCash = "addedCash",
    RefusedCash = "refusedCash",
    NotSupported = "notSupported",
}
